// extracted by mini-css-extract-plugin
module.exports = {"accessible-view-container":"AccessibleContent_accessible-view-container__4S0OL"};